<template>
  <div class="page-wrapper member-view">

    <div class="stats-row">
      <div class="mini-stat" v-for="s in memberStats" :key="s.label">
        <div class="mini-stat-icon" :style="{ background: s.bg, color: s.color }">
          <component :is="s.icon" />
        </div>
        <div>
          <p class="mini-stat-val">{{ s.value }}</p>
          <p class="mini-stat-label">{{ s.label }}</p>
        </div>
      </div>
    </div>

    <div class="page-toolbar member-page-toolbar">
      <div class="page-toolbar-left">
        <div class="filter-tabs">
          <button v-for="tab in filterTabs" :key="tab.value" class="filter-tab"
            :class="{ active: activeFilter === tab.value }" @click="activeFilter = tab.value">{{ tab.label }}</button>
        </div>
        <el-select v-model="filterMemberType" placeholder="会员类型" clearable size="small" class="toolbar-member-type"
          @change="onMemberTypeFilterChange">
          <el-option label="月卡" value="月卡" />
          <el-option label="季卡" value="季卡" />
          <el-option label="年卡" value="年卡" />
          <el-option label="私教" value="私教" />
        </el-select>
      </div>
      <div class="page-toolbar-right">
        <div class="view-toggle">
          <button type="button" class="view-btn" :class="{ active: viewMode === 'grid' }" @click="setViewMode('grid')"><el-icon><Grid /></el-icon></button>
          <button type="button" class="view-btn" :class="{ active: viewMode === 'list' }" @click="setViewMode('list')"><el-icon><List /></el-icon></button>
        </div>
        <button class="btn-primary" @click="openAdd">
          <el-icon><Plus /></el-icon>
          <span>新增会员</span>
        </button>
      </div>
    </div>

    <div class="member-results-shell">
      <template v-if="viewMode === 'grid'">
        <div class="member-grid-wrap">
          <div v-if="filteredMembers.length === 0 && !loading" class="member-grid-empty">暂无会员数据</div>
          <div v-else class="member-grid">
            <div class="member-card" v-for="row in filteredMembers" :key="row.memberId">
              <div class="member-card-top">
                <div class="avatar" :class="{ 'avatar--img': !!row.avatarUrl }" :style="row.avatarUrl ? {} : { background: row.avatarBg }">
                  <img v-if="row.avatarUrl" :src="row.avatarUrl" alt="" />
                  <span v-else>{{ (row.name || '?').charAt(0) }}</span>
                </div>
                <div class="member-card-head-text">
                  <p class="member-name">{{ row.name }}</p>
                  <p class="member-phone">{{ row.phone }}</p>
                </div>
                <div class="status-cell status-cell--card">
                  <span class="status-dot" :class="row.status"></span>
                  <span class="status-text" :class="row.status">{{ row.statusLabel }}</span>
                </div>
              </div>
              <div class="member-card-body">
                <div class="member-card-rows">
                  <div class="member-card-row">
                    <span class="meta-label">类型</span>
                    <span class="tag" :class="`tag-${row.type}`">{{ row.typeLabel }}</span>
                  </div>
                  <div class="member-card-row">
                    <span class="meta-label">注册</span>
                    <span class="meta-value">{{ row.regDate }}</span>
                  </div>
                  <div class="member-card-row">
                    <span class="meta-label">到期</span>
                    <span class="meta-value">{{ row.expireDate }}</span>
                  </div>
                  <div class="member-card-row">
                    <span class="meta-label">消费</span>
                    <span class="amount">{{ row.totalAmount }}</span>
                  </div>
                </div>
                <div class="action-btns member-card-actions">
                  <button class="act-btn view" title="查看" @click="viewMember(row)"><el-icon><View /></el-icon></button>
                  <button class="act-btn edit" title="编辑" @click="editMember(row)"><el-icon><Edit /></el-icon></button>
                  <button class="act-btn del" title="删除" @click="deleteMember(row)"><el-icon><Delete /></el-icon></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="table-card member-table-shell">
          <el-table :data="filteredMembers" style="width:100%" :header-cell-style="headerStyle">
            <el-table-column type="index" label="#" width="60" />
            <el-table-column label="会员信息" min-width="180">
              <template #default="{ row }">
                <div class="member-cell">
                  <div class="avatar" :style="row.avatarUrl ? {} : { background: row.avatarBg }">
                    <img v-if="row.avatarUrl" :src="row.avatarUrl" alt="" />
                    <span v-else>{{ (row.name || '?').charAt(0) }}</span>
                  </div>
                  <div>
                    <p class="member-name">{{ row.name }}</p>
                    <p class="member-phone">{{ row.phone }}</p>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="会员类型" width="120px">
              <template #default="{ row }"><span class="tag" :class="`tag-${row.type}`">{{ row.typeLabel
                  }}</span></template>
            </el-table-column>
            <el-table-column label="状态" width="110px">
              <template #default="{ row }">
                <div class="status-cell"><span class="status-dot" :class="row.status"></span><span class="status-text"
                    :class="row.status">{{ row.statusLabel }}</span></div>
              </template>
            </el-table-column>
            <el-table-column prop="regDate" label="注册时间" width="130" />
            <el-table-column prop="expireDate" label="过期时间" width="130" />
            <el-table-column label="消费金额" width="120">
              <template #default="{ row }"><span class="amount">{{ row.totalAmount }}</span></template>
            </el-table-column>
            <el-table-column label="操作" width="140" fixed="right">
              <template #default="{ row }">
                <div class="action-btns">
                  <button class="act-btn view" @click="viewMember(row)"><el-icon>
                      <View />
                    </el-icon></button>
                  <button class="act-btn edit" @click="editMember(row)"><el-icon>
                      <Edit />
                    </el-icon></button>
                  <button class="act-btn del" @click="deleteMember(row)"><el-icon>
                      <Delete />
                    </el-icon></button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
      <div class="table-footer">
        <span class="total-count">共 {{ total }} 条</span>
        <el-pagination v-model:current-page="currentPage" :page-size="pageSize" :total="total"
          layout="prev, pager, next" background small />
      </div>
    </div>

    <el-dialog v-model="showAddDialog" :title="editingMember ? '编辑会员' : '新增会员'"
      width="520px">
      <el-form :model="memberForm" label-width="80px">
        <el-form-item label="会员姓名">
          <el-input v-model="memberForm.name" placeholder="请输入会员姓名"></el-input>
        </el-form-item>
        <el-form-item label="会员电话">
          <el-input v-model="memberForm.phone" placeholder="请输入会员电话"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="memberForm.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="会员类型">
          <el-select v-model="memberForm.memberType" @change="onMemberTypeChange" style="width:100%">
            <el-option label="月卡" value="月卡" />
            <el-option label="季卡" value="季卡" />
            <el-option label="年卡" value="年卡" />
            <el-option label="私教" value="私教" />
          </el-select>
        </el-form-item>
        <el-form-item label="过期时间">
          <div style="display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 8px;">
            <button v-for="shortcut in currentShortcuts" :key="shortcut.label" 
              type="button" class="shortcut-btn" @click.prevent="applyShortcut(shortcut)">
              {{ shortcut.label }}
            </button>
          </div>
          <el-date-picker v-model="memberForm.expireDate" type="date" placeholder="请选择过期时间"
            style="width:100%" value-format="YYYY-MM-DD" />
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <button class="btn-secondary" @click="showAddDialog = false">取消</button>
          <button class="btn-primary" @click="saveMember">保存</button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { Plus, View, Edit, Delete, Grid, List, UserFilled, Timer, TrendCharts } from '@element-plus/icons-vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import api from '@/api/request';
import { resolveMediaUrl } from '@/utils/media';
import adminListViewModeMixin from '@/mixins/adminListViewMode';

export default {
  name: 'MemberView',
  mixins: [adminListViewModeMixin],
  components: { Plus, View, Edit, Delete, Grid, List, UserFilled, Timer, TrendCharts },
  data() {
    return {
      searchQuery: '',
      activeFilter: 'all',
      filterMemberType: '',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      showAddDialog: false,
      editingMember: null,
      memberForm: { name: '', phone: '', memberType: '月卡', expireDate: '', email: '' },
      memberStats: [
        { label: '总会员数', value: '-', icon: 'UserFilled', bg: 'rgba(0,98,255,0.1)', color: '#0062FF' },
        { label: '正常会员', value: '-', icon: 'TrendCharts', bg: 'rgba(16,185,129,0.1)', color: '#10B981' },
        { label: '过期会员', value: '-', icon: 'Timer', bg: 'rgba(245,158,11,0.1)', color: '#F59E0B' },
      ],
      filterTabs: [
        { label: '全部', value: 'all' },
        { label: '即将到期', value: 'expireSoon' },
        { label: '已过期', value: 'expired' },
      ],
      filteredMembers: [],
      headerStyle: { background: 'var(--bg-elevated)', color: 'var(--text-secondary)', fontWeight: 500 },
      currentShortcuts: [],
      expireSoonListCache: null,
      expireSoonCacheKey: '',
    };
  },
  mounted() {
    this.loadMembers();
    this.loadMemberStats();
  },
  watch: {
    activeFilter() { this.currentPage = 1; this.loadMembers(); },
    currentPage() { this.loadMembers(); },
  },
  methods: {
    async loadMemberStats() {
      try {
        const res = await api.getMemberPage({ pageNumber: 1, pageSize: 1 });
        if (res.data && res.data.code === 200) {
          const total = res.data.data?.totalRow || 0;
          this.memberStats[0].value = String(total);
        }
        const resActive = await api.getMemberPage({ pageNumber: 1, pageSize: 1, notExpired: true });
        if (resActive.data && resActive.data.code === 200) {
          this.memberStats[1].value = String(resActive.data.data?.totalRow || 0);
        }
        const resExpired = await api.getMemberPage({ pageNumber: 1, pageSize: 1, expired: true });
        if (resExpired.data && resExpired.data.code === 200) {
          this.memberStats[2].value = String(resExpired.data.data?.totalRow || 0);
        }
      } catch (e) {}
    },
    todayYmd() {
      const t = new Date();
      const y = t.getFullYear();
      const mo = String(t.getMonth() + 1).padStart(2, '0');
      const da = String(t.getDate()).padStart(2, '0');
      return `${y}-${mo}-${da}`;
    },
    /** 与后端 expired 条件一致：有到期日且早于今天 */
    isExpiredByDate(expireDate) {
      if (expireDate == null || expireDate === '') return false;
      const s = typeof expireDate === 'string' ? expireDate.substring(0, 10) : String(expireDate);
      return s < this.todayYmd();
    },
    /** 未过期且 30 天内到期（含今天） */
    isExpireSoonByDate(expireDate) {
      if (!expireDate || this.isExpiredByDate(expireDate)) return false;
      const s = typeof expireDate === 'string' ? expireDate.substring(0, 10) : String(expireDate);
      const exp = new Date(`${s}T12:00:00`);
      const today = new Date();
      const start = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const diffDays = Math.round((exp - start) / 86400000);
      return diffDays >= 0 && diffDays <= 30;
    },
    statusFromExpireDate(expireDate) {
      return this.isExpiredByDate(expireDate) ? 0 : 1;
    },
    mapMemberRow(m) {
      const expired = this.isExpiredByDate(m.expireDate);
      const rawAv = m.avatar != null ? String(m.avatar).trim() : '';
      const avatarUrl = rawAv ? resolveMediaUrl(rawAv) : '';
      return {
        ...m,
        avatarBg: this.randomColor(m.memberId),
        avatarUrl,
        statusLabel: expired ? '过期' : '正常',
        status: expired ? 'expired' : 'active',
        typeLabel: m.memberType || '-',
        type: { '月卡': 'monthly', '季卡': 'quarterly', '年卡': 'yearly', '私教': 'private' }[m.memberType] || 'monthly',
        regDate: m.createTime ? m.createTime.substring(0, 10) : '-',
        totalAmount: '-',
      };
    },
    async loadMembers() {
      this.loading = true;
      try {
        if (this.activeFilter === 'expireSoon') {
          const cacheKey = `${(this.searchQuery || '').trim()}|${this.filterMemberType || ''}`;
          let list;
          if (this.expireSoonListCache && this.expireSoonCacheKey === cacheKey) {
            list = this.expireSoonListCache;
          } else {
            const res = await api.getMemberList();
            if (!(res.data && res.data.code === 200)) {
              this.filteredMembers = [];
              this.total = 0;
              return;
            }
            list = res.data.data || [];
            const q = (this.searchQuery || '').trim();
            if (q) {
              list = list.filter(m =>
                (m.name && m.name.includes(q)) || (m.username && m.username.includes(q)));
            }
            if (this.filterMemberType) {
              list = list.filter(m => m.memberType === this.filterMemberType);
            }
            list = list.filter(m => this.isExpireSoonByDate(m.expireDate));
            list.sort((a, b) => String(a.expireDate || '').localeCompare(String(b.expireDate || '')));
            this.expireSoonListCache = list;
            this.expireSoonCacheKey = cacheKey;
          }
          this.total = list.length;
          const start = (this.currentPage - 1) * this.pageSize;
          this.filteredMembers = list.slice(start, start + this.pageSize).map(m => this.mapMemberRow(m));
          return;
        }

        this.expireSoonListCache = null;
        this.expireSoonCacheKey = '';

        const params = {
          pageNumber: this.currentPage,
          pageSize: this.pageSize,
        };
        if (this.activeFilter === 'expired') {
          params.expired = true;
        }
        if (this.filterMemberType) {
          params.memberType = this.filterMemberType;
        }
        if (this.searchQuery) params.name = this.searchQuery;

        const res = await api.getMemberPage(params);
        if (res.data && res.data.code === 200) {
          const page = res.data.data;
          this.filteredMembers = (page.records || []).map(m => this.mapMemberRow(m));
          this.total = page.totalRow || 0;
        }
      } catch (e) {
        // 网络错误已由拦截器处理
      } finally {
        this.loading = false;
      }
    },
    randomColor(id) {
      const colors = ['#0062FF', '#10B981', '#EF4444', '#F59E0B', '#8B5CF6', '#06B6D4', '#EC4899'];
      return colors[(id || 0) % colors.length];
    },
    openAdd() {
      this.editingMember = null;
      this.memberForm = { name: '', phone: '', memberType: '月卡', expireDate: '', email: '' };
      this.onMemberTypeChange();
      this.showAddDialog = true;
    },
    editMember(m) {
      this.editingMember = m;
      this.memberForm = {
        memberId: m.memberId,
        name: m.name,
        phone: m.phone,
        email: m.email,
        memberType: m.memberType,
        expireDate: m.expireDate,
        status: this.statusFromExpireDate(m.expireDate),
      };
      this.onMemberTypeChange();
      this.showAddDialog = true;
    },
    viewMember(m) {
      ElMessage.info(`会员 ${m.name}，手机：${m.phone}，类型：${m.typeLabel}`);
    },
    async deleteMember(m) {
      try {
        await ElMessageBox.confirm(`确定删除会员 ${m.name}？`, '提示', { type: 'warning' });
        const res = await api.removeMember(m.memberId);
        if (res.data && res.data.code === 200) {
          ElMessage.success('删除成功');
          this.expireSoonListCache = null;
          this.expireSoonCacheKey = '';
          this.loadMembers();
          this.loadMemberStats();
        } else {
          ElMessage.error(res.data?.message || '删除失败');
        }
      } catch (e) {
        if (e !== 'cancel') ElMessage.error('删除失败');
      }
    },
    async saveMember() {
      try {
        const form = {
          ...this.memberForm,
          status: this.statusFromExpireDate(this.memberForm.expireDate),
        };
        let res;
        if (this.editingMember) {
          res = await api.updateMember(form);
        } else {
          res = await api.saveMember(form);
        }
        if (res.data && res.data.code === 200) {
          ElMessage.success('保存成功');
          this.showAddDialog = false;
          this.expireSoonListCache = null;
          this.expireSoonCacheKey = '';
          this.loadMembers();
          this.loadMemberStats();
        } else {
          ElMessage.error(res.data?.message || '保存失败');
        }
      } catch (e) {
        ElMessage.error('保存失败');
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.loadMembers();
    },
    onMemberTypeFilterChange() {
      this.currentPage = 1;
      this.loadMembers();
    },
    onMemberTypeChange() {
      // 根据会员类型生成快捷选项
      const type = this.memberForm.memberType;
      if (type === '月卡') {
        this.currentShortcuts = [
          { label: '1月', months: 1 },
          { label: '2月', months: 2 },
        ];
      } else if (type === '季卡') {
        this.currentShortcuts = [
          { label: '1季', quarters: 1 },
          { label: '2季', quarters: 2 },
        ];
      } else if (type === '年卡') {
        this.currentShortcuts = [
          { label: '1年', years: 1 },
          { label: '2年', years: 2 },
        ];
      } else {
        this.currentShortcuts = [];
      }
    },
    applyShortcut(shortcut) {
      const today = new Date();
      let expireDate = new Date(today);
      
      if (shortcut.months) {
        expireDate.setMonth(expireDate.getMonth() + shortcut.months);
      } else if (shortcut.quarters) {
        expireDate.setMonth(expireDate.getMonth() + shortcut.quarters * 3);
      } else if (shortcut.years) {
        expireDate.setFullYear(expireDate.getFullYear() + shortcut.years);
      }
      
      // 格式化为 YYYY-MM-DD
      const year = expireDate.getFullYear();
      const month = String(expireDate.getMonth() + 1).padStart(2, '0');
      const day = String(expireDate.getDate()).padStart(2, '0');
      this.memberForm.expireDate = `${year}-${month}-${day}`;
    },
  }
};
</script>

<style scoped>
.page-wrapper {
  padding: 0;
  background: var(--bg-base);
  min-height: 100vh;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.page-title {
  font-size: 22px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 4px;
}

.breadcrumb {
  font-size: 13px;
  color: var(--text-muted);
  display: flex;
  gap: 6px;
}

.breadcrumb .sep {
  color: var(--border-color);
}

.breadcrumb .cur {
  color: var(--primary-blue);
  font-weight: 500;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.search-box {
  display: flex;
  align-items: center;
  background: var(--bg-white);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  padding: 0 12px;
  height: 38px;
  min-width: 260px;
  gap: 8px;
  transition: all 0.3s;
}

.search-box:focus-within {
  border-color: var(--primary-blue);
  box-shadow: 0 0 0 3px rgba(0, 98, 255, 0.08);
}

.search-box .el-icon {
  color: var(--text-muted);
  font-size: 16px;
}

.search-box input {
  border: none;
  background: transparent;
  color: var(--text-primary);
  font-size: 14px;
  outline: none;
  flex: 1;
}

.search-box input::placeholder {
  color: var(--text-muted);
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 18px;
  height: 38px;
  background: var(--gradient-primary);
  color: white;
  border: none;
  border-radius: var(--radius-md);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: var(--shadow-md);
}

.btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-glow);
}

.btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 18px;
  height: 38px;
  background: var(--bg-gray);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-secondary:hover {
  border-color: var(--primary-blue);
  color: var(--primary-blue);
}

.stats-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.mini-stat {
  background: var(--bg-white);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 14px;
  transition: all 0.3s;
}

.mini-stat:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.mini-stat-icon {
  width: 44px;
  height: 44px;
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
}

.mini-stat-val {
  font-size: 22px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 2px;
  font-family: 'Inter', sans-serif;
}

.mini-stat-label {
  font-size: 12px;
  color: var(--text-muted);
  margin: 0;
}

.toolbar-member-type {
  width: 130px;
  flex-shrink: 0;
}

.filter-tabs {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.filter-tab {
  padding: 6px 16px;
  border: 1px solid var(--border-color);
  background: var(--bg-gray);
  color: var(--text-secondary);
  border-radius: var(--radius-sm);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}

.filter-tab:hover {
  border-color: var(--primary-blue);
  color: var(--primary-blue);
}

.filter-tab.active {
  background: var(--primary-blue);
  border-color: var(--primary-blue);
  color: white;
}

.member-results-shell {
  background: var(--bg-white);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  overflow: hidden;
}

.member-results-shell .member-table-shell {
  border: none;
  border-radius: 0;
}

.member-grid-wrap {
  padding: 20px;
}

.member-grid-empty {
  text-align: center;
  padding: 48px 16px;
  font-size: 14px;
  color: var(--text-muted);
}

.member-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
}

.member-card {
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  overflow: hidden;
  background: var(--bg-white);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.member-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.member-card-top {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border-bottom: 1px solid var(--border-light);
}

.member-card-head-text {
  flex: 1;
  min-width: 0;
}

.member-card-head-text .member-name {
  overflow-wrap: anywhere;
  word-break: break-word;
}

.member-card-head-text .member-phone {
  overflow-wrap: anywhere;
}

.status-cell--card {
  flex-shrink: 0;
}

.member-card-body {
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.member-card-rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.member-card-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  font-size: 13px;
}

.meta-label {
  color: var(--text-muted);
  flex-shrink: 0;
}

.meta-value {
  color: var(--text-primary);
  text-align: right;
}

.member-card-actions {
  justify-content: flex-end;
}

.view-toggle {
  display: flex;
  gap: 4px;
}

.view-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-color);
  background: var(--bg-white);
  color: var(--text-muted);
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all 0.25s ease;
}

.view-btn.active {
  background: rgba(0, 98, 255, 0.1);
  color: var(--primary-blue);
  border-color: var(--primary-blue);
}

.avatar.avatar--img {
  background: transparent;
}

.table-card {
  background: var(--bg-white);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  overflow: hidden;
}

.member-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 15px;
  flex-shrink: 0;
  overflow: hidden;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.member-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 2px;
}

.member-phone {
  font-size: 12px;
  color: var(--text-muted);
  margin: 0;
}

.tag {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.tag-yearly {
  background: rgba(0, 98, 255, 0.1);
  color: #0062FF;
}

.tag-quarterly {
  background: rgba(16, 185, 129, 0.1);
  color: #10B981;
}

.tag-monthly {
  background: rgba(245, 158, 11, 0.1);
  color: #F59E0B;
}

.tag-private {
  background: rgba(139, 92, 246, 0.1);
  color: #8B5CF6;
}

.status-cell {
  display: flex;
  align-items: center;
  gap: 6px;
}

.status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}

.status-dot.active {
  background: #10B981;
}

.status-dot.expired {
  background: #EF4444;
}

.status-text {
  font-size: 13px;
  font-weight: 500;
}

.status-text.active {
  color: #10B981;
}

.status-text.expired {
  color: #EF4444;
}

.amount {
  font-weight: 700;
  color: var(--primary-blue);
  font-family: 'Inter', sans-serif;
}

.action-btns {
  display: flex;
  gap: 6px;
}

.act-btn {
  width: 30px;
  height: 30px;
  border: none;
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
}

.act-btn.view {
  background: rgba(0, 98, 255, 0.1);
  color: #0062FF;
}

.act-btn.view:hover {
  background: #0062FF;
  color: white;
}

.act-btn.edit {
  background: rgba(245, 158, 11, 0.1);
  color: #F59E0B;
}

.act-btn.edit:hover {
  background: #F59E0B;
  color: white;
}

.act-btn.del {
  background: rgba(239, 68, 68, 0.1);
  color: #EF4444;
}

.act-btn.del:hover {
  background: #EF4444;
  color: white;
}

.table-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid var(--border-color);
}

.total-count {
  font-size: 13px;
  color: var(--text-muted);
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.shortcut-btn {
  padding: 6px 12px;
  background: var(--bg-gray);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  font-size: 13px;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.3s;
  white-space: nowrap;
}

.shortcut-btn:hover {
  border-color: var(--primary-blue);
  color: var(--primary-blue);
  background: rgba(0, 98, 255, 0.05);
}

/* 适配移动端和响应式布局 */
@media (max-width: 768px) {
  
  .member-view .stats-row {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
    margin-bottom: 12px;
  }

  .member-view .mini-stat {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 8px 4px;
    gap: 4px;
    aspect-ratio: 1;
    min-height: 0;
    border-radius: var(--radius-md);
  }

  .member-view .mini-stat:hover {
    transform: none;
    box-shadow: none;
  }

  .member-view .mini-stat-icon {
    width: 28px;
    height: 28px;
    font-size: 15px;
    border-radius: var(--radius-sm);
  }

  .member-view .mini-stat-val {
    font-size: 14px;
    margin: 0;
    line-height: 1.15;
  }

  .member-view .mini-stat-label {
    font-size: 10px;
    line-height: 1.25;
    max-width: 100%;
    overflow-wrap: anywhere;
  }
  
  .page-toolbar {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 10px 12px;
  }

  .member-page-toolbar .page-toolbar-left {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .member-page-toolbar .filter-tabs {
    width: 100%;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 6px;
    gap: 6px;
    scrollbar-width: thin;
    flex-shrink: 0;
  }

  .member-page-toolbar .filter-tab {
    padding: 6px 12px;
    font-size: 12px;
    flex-shrink: 0;
    white-space: nowrap;
  }

  .toolbar-member-type {
    width: 100% !important;
    max-width: none;
    flex-shrink: 0;
  }

  .page-toolbar-right {
    margin-left: 0;
    width: 100%;
    justify-content: stretch;
  }

  .member-page-toolbar .page-toolbar-right {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 10px;
    align-items: center;
  }

  .member-page-toolbar .page-toolbar-right .btn-primary {
    justify-self: stretch;
    display: inline-flex;
    justify-content: center;
    min-height: 40px;
  }

  .member-grid-wrap {
    padding: 12px;
  }

  .member-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .member-card-top {
    padding: 14px;
    gap: 10px;
  }

  .member-card-body {
    padding: 12px 14px;
  }

  .member-card-actions {
    padding-top: 4px;
    border-top: 1px solid var(--border-light);
  }

  .table-footer {
    flex-direction: column;
    align-items: stretch;
    padding: 12px 14px;
  }

  .table-footer :deep(.el-pagination) {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    row-gap: 8px;
    width: 100%;
  }
  
  .table-card {
    overflow-x: auto;
  }
}

@media (max-width: 480px) {
  .member-view .stats-row {
    gap: 6px;
  }

  .member-view .mini-stat {
    padding: 6px 2px;
    gap: 3px;
  }

  .member-view .mini-stat-icon {
    width: 24px;
    height: 24px;
    font-size: 13px;
  }

  .member-view .mini-stat-val {
    font-size: 13px;
  }

  .member-view .mini-stat-label {
    font-size: 9px;
  }

  .member-results-shell {
    border-radius: var(--radius-md);
  }
}
</style>
